import {
  ChangeDetectorRef,
  Component,
  effect,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { Router } from '@angular/router';
import { QueryLoadingState } from '@globalconnect/query';
import { FlexibleColumn, IpoLanguageService } from '@ip-only/front-end-library';
import { Observable, of, switchMap, tap } from 'rxjs';
import {
  InstallationReportOrderDetail,
  InstallationReportResponseV2,
} from '../../../../shared/installation-report-content-v2/installation-report-content-entities';
import { IR_INSTALLATION_REPORT_OPENED } from '../../../../shared/posthug-analytics/analytics-event-types';
import { AnalyticsService } from '../../../../shared/posthug-analytics/analytics.service';
import { isTopLevelDomainFI } from '../../../../shared/util/deploy-helper';
import { OrdersOverviewResponse } from '../../../../span-progress-app/span-progress-report/orders-overview-modal/orders-overview-entities';
import { Domain } from '../../../entities/installation-reporting-entities';
import { InstallationReportingV2Service } from '../../../service/sdu/installation-reporting-v2.service';
import { configureFlexibleColumns } from './../table-columns/installation-reporting.columns.utils';

@Component({
  selector: 'app-installation-reporting-table',
  templateUrl: './installation-reporting-table.component.html',
  styleUrls: ['./installation-reporting-table.component.scss'],
  standalone: false,
})
export class InstallationReportingTableComponent implements OnInit {
  @Input() ifs: string;
  @Input() filterText: string;
  @Input() filterFields: string[];
  @Input() isLoading: boolean;
  @Input() set installationReports(
    installationReports: InstallationReportOrderDetail[],
  ) {
    this._installationReports = installationReports.filter(
      (installationReport) => installationReport.deliveryOrderId !== null,
    );
  }

  get installationReports() {
    return this._installationReports ?? [];
  }

  private _installationReports: InstallationReportOrderDetail[];

  language$ = this.languageService.getLanguage$();
  loadingRows = new Array(10).fill(0);
  savedInstallationReportsResponse$: Observable<
    QueryLoadingState<InstallationReportResponseV2[]>
  >;
  readonly currentDomain = signal<Domain>(isTopLevelDomainFI() ? 'FI' : 'SE');
  readonly columns = signal<FlexibleColumn[]>([]);

  constructor(
    private readonly languageService: IpoLanguageService,
    private readonly installationReportingServiceV2: InstallationReportingV2Service,
    private readonly analyticsService: AnalyticsService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly router: Router,
  ) {
    effect(() => {
      this.getTableColumns();
    });
  }

  ngOnInit() {
    this.getInstallationReports();
    this.getInstallationReportsOnUpdate();
  }

  getInstallationReports() {
    this.savedInstallationReportsResponse$ =
      this.installationReportingServiceV2.getAllInstallationReportsForProject$(
        this.ifs,
      );
  }

  getInstallationReportsOnUpdate() {
    this.installationReportingServiceV2.retriggerGetAll$
      .pipe(
        switchMap(() =>
          this.installationReportingServiceV2.getAllInstallationReportsForProject$(
            this.ifs,
          ),
        ),
        tap((res) => {
          this.savedInstallationReportsResponse$ = of(res);
          this.changeDetector.detectChanges();
        }),
      )
      .subscribe();
  }

  getTableColumns(): void {
    this.columns.set(configureFlexibleColumns(this.currentDomain(), 'SDU'));
  }

  openInstallationReportModal(order: OrdersOverviewResponse) {
    this.analyticsService.logEvent(IR_INSTALLATION_REPORT_OPENED);
    this.router.navigate([
      '/installation-reporting',
      this.ifs,
      order.deliveryOrderId,
    ]);
  }
}
